/* eslint-disable import/prefer-default-export */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef } from 'react';
import { useInfiniteQuery, useMutation } from 'react-query';
import Highlighter from 'react-highlight-words';
import { Button, Col, Row, Dropdown, Spinner, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { StyledTh } from './styles';
import { ReactComponent as More } from '../../../../assets/images/icons/more.svg';
import { ReactComponent as List } from '../../../../assets/images/icons/list.svg';
import { ReactComponent as Eraser } from '../../../../assets/images/icons/eraser-solid.svg';
import { useCompanyHttpService } from '../../../../services/http/company-http';
import useIntersectionObserver from '../../../../hooks/useIntersectionObserver';
import formatDate from '../../../../utils/localization/formatDate';
import { rowsPerPage } from '../../../../constants/pagination';
import { useCompany } from '../../../../contexts/companyContext';
import confirmDialog from '../../../../utils/dialog/confirmDialog';
import isFriendlyHttpError from '../../../../utils/isFriendlyHttpError';

const StatusTable = (props: any) => {
    const {
        formData: filter,
        setSelectedCompany,
        setShowStatusDetailModal,
        setSelectedStatus,
        selectedCompany,
        reset,
    } = useCompany();

    const { indexStatuses, removeStatus } = useCompanyHttpService();

    const loadMoreRef = useRef();

    const mutationDelete = useMutation(
        async (id: number) => {
            await removeStatus({
                statusId: id,
            });
        },
        {
            onError: (error: any) => {
                if (isFriendlyHttpError(error)) {
                    toast.error(error.message);

                    return;
                }

                toast.error('Ocorreu um erro ao excluir o status.');
            },
            onSuccess: () => {
                toast.success('Status excluído com sucesso!');
            },
            onSettled: () => {
                refetch();
            },
        },
    );

    const loadCompanyStatuses = async ({ pageParam = 0 }: any) => {
        const params = {
            companyId: selectedCompany.id,
            skip: pageParam,
            take: rowsPerPage,
        };

        const response: any = await indexStatuses(params);

        return {
            data: response.data.data,
            nextPage: pageParam,
        };
    };

    const { data, fetchNextPage, hasNextPage, isFetchingNextPage, refetch } =
        useInfiniteQuery('companyStatuses', loadCompanyStatuses, {
            getNextPageParam: (lastPage) => lastPage.nextPage + 1,
        });

    useIntersectionObserver({
        target: loadMoreRef,
        onIntersect: fetchNextPage,
        enabled: hasNextPage,
    });

    useEffect(() => {
        const timer = setTimeout(() => {
            refetch();
        }, 500);

        return () => clearTimeout(timer);
    }, [filter, refetch, reset]);

    return (
        <>
            <Row>
                <Col className="ml-2 mr-2">
                    <Table bordered hover size="sm" className="text-center">
                        <thead>
                            <tr>
                                <StyledTh>CODIGO DA TRANSPORTADORA</StyledTh>
                                <StyledTh>STATUS CORRESPONDENTE</StyledTh>
                                <StyledTh>COD. STATUS CORRESPONDENTE</StyledTh>
                                <StyledTh>ULTIMA ATUALIZAÇÃO</StyledTh>
                            </tr>
                        </thead>

                        <tbody>
                            {data?.pages &&
                                data?.pages.map((group: any) =>
                                    group?.data.map(
                                        (item: any, index2: any) => (
                                            <tr key={index2}>
                                                <td>
                                                    <Highlighter
                                                        autoEscape
                                                        highlightClassName="highlight-term"
                                                        searchWords={[
                                                            filter.term,
                                                        ]}
                                                        textToHighlight={item?.code.toString()}
                                                    />
                                                </td>
                                                <td>
                                                    <Highlighter
                                                        autoEscape
                                                        highlightClassName="highlight-term"
                                                        searchWords={[
                                                            filter.term,
                                                        ]}
                                                        textToHighlight={item?.status.desc.toString()}
                                                    />
                                                </td>
                                                <td>
                                                    <Highlighter
                                                        autoEscape
                                                        highlightClassName="highlight-term"
                                                        searchWords={[
                                                            filter.term,
                                                        ]}
                                                        textToHighlight={item?.status.defaultCode.toString()}
                                                    />
                                                </td>
                                                <td>
                                                    {formatDate(
                                                        item?.updatedAt.toString(),
                                                    )}
                                                </td>
                                                <td className={'d-flex'}>
                                                    {}
                                                    <Dropdown key="left">
                                                        <Dropdown.Toggle
                                                            bsPrefix="nexen"
                                                            as={Button}
                                                            variant="text"
                                                        >
                                                            <More
                                                                width="10"
                                                                height="20"
                                                            />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    setSelectedStatus(
                                                                        item,
                                                                    );
                                                                    setShowStatusDetailModal(
                                                                        true,
                                                                    );
                                                                }}
                                                            >
                                                                <List
                                                                    width="18"
                                                                    height="18"
                                                                    className="ml-n3 mr-2"
                                                                />
                                                                Detalhes
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={async () => {
                                                                    const confirm: any =
                                                                        await confirmDialog(
                                                                            'Excluir status',
                                                                            'Deseja excluir o status selecionado?',
                                                                            'info',
                                                                        );

                                                                    if (
                                                                        !confirm
                                                                    ) {
                                                                        return;
                                                                    }

                                                                    mutationDelete.mutateAsync(
                                                                        item?.id,
                                                                    );
                                                                }}
                                                            >
                                                                <Eraser
                                                                    width="18"
                                                                    height="18"
                                                                    className="ml-n3 mr-2"
                                                                />
                                                                Excluir
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        ),
                                    ),
                                )}
                        </tbody>
                    </Table>
                </Col>

                <Col md={12} className="text-center">
                    {isFetchingNextPage ? (
                        <Col md={12} className="text-center">
                            <Spinner animation={'border'} />
                        </Col>
                    ) : (
                        <Col md={12} className="text-center">
                            <strong style={{ color: '#adadad' }}>
                                Sem itens para carregar
                            </strong>
                        </Col>
                    )}
                </Col>
            </Row>
        </>
    );
};

export { StatusTable };
